import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [];

  connect() {
    // Ensure script is loaded once; loader is handled in include/crispChatWrapper.js
  }

  open(event) {
    event && event.preventDefault();
    window.$crisp && window.$crisp.push(['do', 'chat:open']);
  }

  close(event) {
    event && event.preventDefault();
    window.$crisp && window.$crisp.push(['do', 'chat:close']);
  }

  reset(event) {
    event && event.preventDefault();
    window.$crisp && window.$crisp.push(['do', 'session:reset']);
  }
}


